module.exports = __webpack_public_path__ + "static/invest_nwa_full_logo_color-4b459379c82ea9e91a54434643b6850f.png";